export class SalesforceGetObjectsResultPayload {
	objectList: string[] = [];
}
